import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../redux/actions/userActions';
import { useHistory } from 'react-router-dom';

/**
 * Checks if the BC access token is valid and logs the user out if not
 */
export const useTokenCheck = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.userReducer.loggedIn);
  let allowedSessionLength = parseInt(
    localStorage.getItem('allowedSessionLength')
  );
  const timeOfLogin = localStorage.getItem('timeOfLogin');
  const sessionLength = (new Date() - new Date(timeOfLogin)) / 1000;
  if (
    loggedIn &&
    (!sessionLength || !timeOfLogin || sessionLength > allowedSessionLength)
  ) {
    dispatch(logOut());
    history.push('login/tokenExpired');
  }
};
